import React from 'react';
import { colors } from '../../../../../colorVars';

type Props = {
  /**
   * Size of icon in pixels
   */
  size: string;
  margin: string;
};

export const BiDirectionalArrow = ({ size, margin }: Props) => {
  return (
    <svg
      x="0px"
      y="0px"
      width={size}
      height={size}
      viewBox="0 0 64 64"
      preserveAspectRatio="xMidYMid meet"
    >
      <circle cx="32" cy="32" r="30" fill={colors.blue}></circle>
      <path d="M32 52l16-15.5H36.6v-9H48L32 12L16 27.5h11.4v9H16z"></path>
    </svg>
  );
};
